import { activities } from "./activities/activities";
import { adders } from "./adders/adders";
import { attributes } from "./attributes/attributes";
import { categories } from "./categories/categories";
import { cities } from "./cities/cities";
import { communities } from "./communities/communities";
import { draws } from "./draws/draws";
import { floors } from "./floors/floors";
import { homes } from "./homes/homes";
import { materials } from "./materials/materials";
import { plans } from "./plans/plans";
import { pricing } from "./pricing/pricing";
import { series } from "./series/series";
import { accountDrops } from "./accountDrops/accountDrops";
import { accountPricing } from "./accountPricing/accountPricing";
import { areaTypes } from "./areaTypes/areaTypes";
import { bidLineItems } from "./bidLineItem/bidLineItem";
import { communityVendors } from "./communityVendors/communityVendors";
import { dropPriceLevel } from "./dropPriceLevel/dropPriceLevel";
import { dropPrices } from "./dropPrices/dropPrices";
import { dropTypes } from "./dropTypes/dropTypes";
import { priceLevel } from "./priceLevel/priceLevel";
import { seriesGroup } from "./seriesGroup/seriesGroup";
import { inspectionAuthorities } from "./inspectionAuthorities/inspectionAuthorities";
import { requirements } from "./requirements/requirements";

export const homeService = {
  homes,
  communities,
  communityVendors,
  plans,
  areaTypes,
  bidLineItems,
  cities,
  activities,
  attributes,
  categories,
  materials,
  pricing,
  accountPricing,
  accountDrops,
  adders,
  dropTypes,
  floors,
  series,
  seriesGroup,
  draws,
  dropPrices,
  priceLevel,
  dropPriceLevel,
  inspectionAuthorities,
  requirements
};
